<mat-form-field class="dict-commission-tables" >
  <mat-label>{{ label }}</mat-label>
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event.value)"  >
    <mat-option>
      <ngx-mat-select-search
        [formControl]="searchControl"
        placeholderLabel="Wyszukaj..."
        noEntriesFoundLabel="Nie znaleziono tabeli prowizyjnej"
      >
      </ngx-mat-select-search>

    </mat-option>

    <mat-option
      *ngFor="
    let commissionTable
    of filteredItems
  "
      [value]="commissionTable.uuid"
      multiLineOption
    >

      <h4 mat-line>
        {{ commissionTable.shortName }}
        -
        {{ commissionTable.name }}
      </h4>

      <p mat-line class="validNote">
        Obowiązuje: {{ commissionTable.validFrom | date:'y-MM-dd' }} -
        {{
          commissionTable.validTo
            ? (commissionTable.validTo | date:'y-MM-dd')
            : 'bezterminowo'
        }}
      </p>

    </mat-option>

  </mat-select>

  <button
    *ngIf="
      control.value
      && !required
    "
    matSuffix
    mat-icon-button
    type="button"
    aria-label="Wyczyść"
    (click)="
      clearValue();
      $event.stopPropagation()
    "
  >
    <mat-icon>
      close
    </mat-icon>
  </button>

  <mat-error
    *ngIf="
      control.hasError('required')
    "
  >
    To pole jest wymagane
  </mat-error>

  <mat-error
    *ngIf="
      control.hasError('backendError')
    "
  >
    {{
      control.getError(
        'backendError'
      )
    }}
  </mat-error>

</mat-form-field>
